import { BlueBirdTheme } from "@kitbird/core";
import styled from "styled-components";

const { blueGray } = BlueBirdTheme.colors;

// eslint-disable-next-line import/prefer-default-export
export const ActionSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  label,
  input::placeholder {
    font-weight: 500 !important;
    color: ${blueGray.light};
  }
  input {
    font-size: 14px;
  }
`;
